import api from './api';

export const educationCategoryService = {
    create: (data) => api.post('/educationcategory', data),
    getAll: (params) => api.get('/educationcategory', { params }),
    update: (id, data) => api.put(`/educationcategory/${id}`, data),
    delete: (id) => api.delete(`/educationcategory/${id}`),
};